import AdvantagesAdmin from './views/AdvantagesAdmin';
export default AdvantagesAdmin;
